import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { addDefaultSrc } from '../../utils'
import { selectCategory, selectSubCategory } from '../../actions'
import './FeaturedCategories.scss'
import { mixpanelLogEvent } from '../../utils/mixpanelLogEvent'

const { REACT_APP_STORAGE_URL, REACT_APP_CONT_PRODUCT_CAT } = process.env
const IMAGE_URL = REACT_APP_STORAGE_URL + REACT_APP_CONT_PRODUCT_CAT

class FeaturedCategoriesCard extends Component {
  selectCategory = () => {
    this.props.selectCategory(this.props.cat)
  }

  render() {
    const { name } = this.props.cat
    const catName = name.length < 24 ? name : name.substr(0, 20) + '...'

    return (
      <Fragment>
        <div className="col-sm-4 col-xl-3 category-card-wrapper">
          <div
            className="category-card"
            onClick={() => {
              mixpanelLogEvent({
                eventType: `Shop_Page_Category_Button_Click`,
                userDetails: this?.props?.auth?.user,
                metaData: { category: catName },
              })
            }}
          >
            <Link onClick={() => this.selectCategory()} to={{ pathname: this.props.link }}>
              {/* <img onError={addDefaultSrc} src={IMAGE_URL + this.props.cat.imageUrl} alt={this.props.alt} /> */}
              <img
                onError={addDefaultSrc}
                src={this.props.cat.imageUrl}
                alt={this.props.alt}
                loading="lazy"
              />
            </Link>
            <div className="category-card-title">{catName}</div>
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  }
}

// export default (connect(mapStateToProps, null)(TransactionHOC(CartHOC(ReorderItemsCard))))

export default connect(mapStateToProps, { selectCategory, selectSubCategory })(
  FeaturedCategoriesCard,
)
